import { Controller } from "@hotwired/stimulus"
import { get } from "@rails/request.js"

export default class extends Controller {
  static targets = ["modal", "previewContent", "confirmButton", "closeButton"]
  static values = { patientId: String }

  connect() {
    this.processing = false
    this.boundHandleShowPreview = this.handleShowPreview.bind(this)
    this.boundSubmitEnd = this.handleSubmitEnd.bind(this)
    document.addEventListener("show-invoice-preview", this.boundHandleShowPreview)
  }

  disconnect() {
    document.removeEventListener("show-invoice-preview", this.boundHandleShowPreview)
    this.teardownSubmitListener()
  }

  handleShowPreview(event) {
    if (this.processing) return

    this.form = event.detail.form
    this.openModal()
    this.loadPreview()
  }

  openModal() {
    this.modalTarget.classList.remove("hidden")
    document.body.style.overflow = "hidden"
  }

  closeModal() {
    if (this.processing) return

    this.modalTarget.classList.add("hidden")
    this.modalTarget.setAttribute("aria-hidden", "true")
    document.body.style.overflow = ""
    this.previewContentTarget.innerHTML = ""
  }

  async loadPreview() {
    const formData = new FormData(this.form)
    const params = new URLSearchParams(formData)
    const url = `/receptionist/cash/${this.patientIdValue}/preview_payment.html?${params}`

    this.confirmButtonTarget.disabled = true
    this.previewContentTarget.innerHTML = '<div class="flex items-center justify-center py-12"><div class="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div></div>'

    try {
      const response = await get(url)
      if (response.ok) {
        const html = await response.text
        this.previewContentTarget.innerHTML = html
      } else {
        this.previewContentTarget.innerHTML = '<p class="text-red-600 py-8 text-center">No se pudo cargar la vista previa. Intente de nuevo.</p>'
      }
    } catch (error) {
      this.previewContentTarget.innerHTML = '<p class="text-red-600 py-8 text-center">Error al cargar la vista previa. Intente de nuevo.</p>'
    } finally {
      if (!this.processing) this.confirmButtonTarget.disabled = false
    }
  }

  confirmPayment() {
    if (this.processing || !this.form) return

    this.startProcessing()
    this.form.dataset.previewConfirmed = "1"
    this.form.addEventListener("turbo:submit-end", this.boundSubmitEnd)
    this.form.requestSubmit()
  }

  startProcessing() {
    this.processing = true
    if (this.form) this.form.dataset.comprobanteProcessing = "1"
    this.confirmButtonTarget.disabled = true
    this.closeButtonTargets.forEach((button) => {
      button.disabled = true
    })
    document.body.style.overflow = "hidden"
  }

  stopProcessing() {
    this.processing = false
    if (this.form) delete this.form.dataset.comprobanteProcessing
    if (this.hasConfirmButtonTarget) this.confirmButtonTarget.disabled = false
    this.closeButtonTargets.forEach((button) => {
      button.disabled = false
    })
  }

  handleSubmitEnd(event) {
    this.teardownSubmitListener()

    if (event.detail?.success) return
    if (!this.element.isConnected) return

    this.stopProcessing()
  }

  teardownSubmitListener() {
    if (this.form) {
      this.form.removeEventListener("turbo:submit-end", this.boundSubmitEnd)
    }
  }
}
